import { render } from "./PartnerClientToAddListView.vue?vue&type=template&id=170b0a45&scoped=true"
import script from "./PartnerClientToAddListView.vue?vue&type=script&lang=js"
export * from "./PartnerClientToAddListView.vue?vue&type=script&lang=js"

import "./PartnerClientToAddListView.vue?vue&type=style&index=0&id=170b0a45&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170b0a45"]])

export default __exports__